import OldPropertyAlertButton from './old-property-alert-button';
export default OldPropertyAlertButton;